var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{attrs:{"allowfullscreen":"","src":`${_vm.widgetUrl}/?${_vm.widgetQuery}`,"allow":"camera;microphone","id":"botter-iframe"}})
}
var staticRenderFns = []

export { render, staticRenderFns }